export default __webpack_public_path__ + "static/media/INSOMNIA.0b69b8f8.png";